
import { useState } from "react";

type UseNodeResizeProps = {
  id: string;
  nodeWidth: number;
  nodeHeight: number;
  updateNodeData: (id: string, data: any) => void;
};

export const useNodeResize = ({ 
  id, 
  nodeWidth, 
  nodeHeight, 
  updateNodeData 
}: UseNodeResizeProps) => {
  const [isResizing, setIsResizing] = useState(false);
  
  const handleResizeStart = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsResizing(true);
    
    const startX = e.clientX;
    const startY = e.clientY;
    const startWidth = nodeWidth;
    const startHeight = nodeHeight;
    
    const onMouseMove = (moveEvent: MouseEvent) => {
      moveEvent.preventDefault();
      moveEvent.stopPropagation();
      
      // Calculate the new dimensions
      const newWidth = Math.max(150, startWidth + (moveEvent.clientX - startX));
      const newHeight = Math.max(60, startHeight + (moveEvent.clientY - startY));
      
      // Update the node dimensions
      updateNodeData(id, { 
        width: newWidth,
        height: newHeight 
      });
    };
    
    const onMouseUp = () => {
      setIsResizing(false);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };
    
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  return {
    isResizing,
    handleResizeStart
  };
};
